var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SignInSignUpLayout',[_c('div',{staticClass:"wrapper"},[_c('h1',{staticClass:"sign-in-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"text text-center"},[_vm._t("default")],2),_vm._t("button")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }